import { FilterQueryPropsValue } from '@global/filter/FilterQueryModal'

export const extractValueFromFilterQuery = (
  filterQueryPropsValue: FilterQueryPropsValue
): string => {
  const value =
    typeof filterQueryPropsValue === 'object' ? filterQueryPropsValue.value : filterQueryPropsValue

  if (value === undefined) {
    return ''
  }

  return value.toString()
}
